import React from 'react';
import { Table } from 'react-bootstrap';
import { ReactComponent as EditIcon } from '../../../assets/images/Edit.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/images/Delete.svg';
import AddNewButton from '../../../Common/AddNewButton';
import '../../BannerManagement/components/BannerList.css';
import '../../WeeklyReports/components/WeeklyReportsTable.css';
import './TournamentList.css';
import { format } from 'date-fns';
import Select from 'react-select';

interface Tournament {
  id: number;
  name: string;
  shortName: string;
  location: string;
  sport: string;
  startDate: string;
  endDate: string;
  logo?: string;
  status?: string;
}

interface TournamentListProps {
  tournaments: Tournament[];
  search: string;
  onSearch: (value: string) => void;
  onEdit: (idx: number) => void;
  onDelete: (idx: number) => void;
  onAdd: () => void;
  sportFilter: any;
  setSportFilter: (option: any) => void;
  sportOptions: any[];
  locationFilter: any;
  setLocationFilter: (option: any) => void;
  locationOptions: any[];
  statusFilter: any;
  setStatusFilter: (option: any) => void;
  statusOptions: any[];
}

const TournamentList: React.FC<TournamentListProps> = ({ tournaments, search, onSearch, onEdit, onDelete, onAdd, sportFilter, setSportFilter, sportOptions, locationFilter, setLocationFilter, locationOptions, statusFilter, setStatusFilter, statusOptions }) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3 gap-3">
          <div className="d-flex align-items-center gap-3" style={{ flex: 1 }}>
            <input
              type="text"
              className="form-control"
              style={{ minWidth: 220, maxWidth: 260, height: 40, borderRadius: 8 }}
              placeholder="Search tournaments..."
              value={search}
              onChange={e => onSearch(e.target.value)}
            />
            <div style={{ minWidth: 180 }}>
              <Select
                classNamePrefix="react-select"
                name="sportFilter"
                value={sportFilter}
                onChange={setSportFilter}
                options={sportOptions}
                placeholder="Sport"
                isClearable
                isSearchable
                styles={{ control: base => ({ ...base, minHeight: '40px', borderRadius: 8, fontSize: 14 }) }}
              />
            </div>
            <div style={{ minWidth: 180 }}>
              <Select
                classNamePrefix="react-select"
                name="locationFilter"
                value={locationFilter}
                onChange={setLocationFilter}
                options={locationOptions}
                placeholder="Location"
                isClearable
                isSearchable
                styles={{ control: base => ({ ...base, minHeight: '40px', borderRadius: 8, fontSize: 14 }) }}
              />
            </div>
            <div style={{ minWidth: 180 }}>
              <Select
                classNamePrefix="react-select"
                name="statusFilter"
                value={statusFilter}
                onChange={setStatusFilter}
                options={statusOptions}
                placeholder="Status"
                isClearable
                isSearchable
                styles={{ control: base => ({ ...base, minHeight: '40px', borderRadius: 8, fontSize: 14 }) }}
              />
            </div>
          </div>
          <AddNewButton onClick={onAdd} label="Add Tournament" />
        </div>
        <div className="custom-table-responsive">
          <Table className="custom-table table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Abbreviation</th>
                <th>Location</th>
                <th>Sport</th>
                <th>Status</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tournaments.map((t, idx) => (
                <tr key={t.id}>
                  <td>{t.name}</td>
                  <td>{t.shortName}</td>
                  <td><span className="custom-badge custom-badge-blue">{t.location || ''}</span></td>
                  <td>{t.sport ? <span className="custom-badge custom-badge-green">{t.sport}</span> : ''}</td>
                  <td>{t.status ? <span className={`custom-badge custom-badge-${t.status === 'ongoing' ? 'green' : t.status === 'completed' ? 'gray' : 'yellow'}`}>{t.status.charAt(0).toUpperCase() + t.status.slice(1)}</span> : ''}</td>
                  <td>{t.startDate ? format(new Date(t.startDate), 'dd-MM-yyyy') : ''}</td>
                  <td>{t.endDate ? format(new Date(t.endDate), 'dd-MM-yyyy') : ''}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <button
                        className="icon-btn edit-btn"
                        onClick={() => onEdit(idx)}
                        title="Edit"
                        type="button"
                      >
                        <EditIcon />
                      </button>
                      <button
                        className="icon-btn delete-btn"
                        onClick={() => onDelete(idx)}
                        title="Delete"
                        type="button"
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {tournaments.length === 0 && (
                <tr>
                  <td colSpan={8} className="text-center">No tournaments found.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default TournamentList; 